import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  /**
   * Store
   */
  reduce_formik_pool: ['formik_pool'],
  reduce_metadata: ['metadata'],
  reduce_products: ['products'],
  reduce_vehicle_brands: ['vehicle_brands'],
  reduce_vehicle_mop_brands: ['vehicle_mop_brands'],
  reduce_vehicle_models: ['vehicle_models'],
  reduce_vehicle_mop_models: ['vehicle_mop_models'],
  reduce_vehicle_versions: ['vehicle_versions'],
  reduce_residence_municipalities: ['residence_municipalities'],
  reduce_agencies: ['agencies'],
  reduce_quote: ['quote'],
  reduce_quotedoc: ['quotedoc'],
  reduce_otherdocs: ['otherdocs'],
  reduce_otherdoc: ['otherdoc'],
  reduce_municipalities_temp: ['municipalities_temp'], // TODO: Rimuovere
  reduce_cookie_informatives: ['cookie_informatives'],
  reduce_documents: ['documents'],
  reduce_document: ['document'],

  /**
   * Sagas
   */
  saga_resolve_fpool_general: ['args'],
  saga_resolve_fpool_special: ['args'],
  saga_resolve_fpool_fastquote: ['args'],
  saga_resolve_products: ['args'],
  saga_resolve_vehicle_brands: ['args'],
  saga_resolve_vehicle_models: ['args'],
  saga_resolve_vehicle_versions: ['args'],
  saga_resolve_residence_municipalities: ['args'],
  saga_resolve_agencies: ['args'],
  saga_require_quote: ['args'],
  saga_resolve_quotedoc: ['args'],
  saga_resolve_otherdocs: ['args'],
  saga_resolve_otherdoc: ['args'],
  saga_resolve_parameters: ['args'],
  saga_resolve_document: ['args'],
})

export const data_types = Types
export const data_creators = Creators
